module.exports = __webpack_public_path__ + "static/media/child2.93731296.png";